<template lang="html">
    <modal dialog="modal-lg" class="dark-top" :footer="false" :headerStyle="{'background-color':currentIntegration.color.main}">
        <div slot="title">
            <h2>{{currentIntegration.label}}</h2>
        </div>

        <div slot="body">
            <!-- Top area -->
            <top-area :integration="currentIntegration" >
               <div class="bg-blue-pale p-2">
                    Please note: This integration is exclusively available for OTAs that use the OCTO standard.
                </div>
            </top-area>

            <div class="px-5 pb-4">
                <div class="form-group-min-height row py-3">
                    <div class="col-sm-12">
                        <label class="full">
                            Email<span class="brand ml-1">*</span>
                            <input type="text" disabled v-model="currentIntegration.email">
                        </label>
                    </div>

                    <div class="col-sm-12 py-2">
                        <label for="stripeSecretKey">Integration Key</label>
                        <input name="stripeSecretKey" type="text" class="w-100" disabled v-model="currentIntegration.apiKey">

                        <label for="stripePublicKey" class="pt-2">Base Endpoint</label>
                        <input name="stripePublicKey" type="text" class="w-100" disabled v-model="currentIntegration.baseUrl">
                    </div>
                </div>
               
                <bottom-area
                    :isIntegrated="currentIntegration.integrationStatus == 1"
                    :showConnectBtn="currentIntegration.integrationStatus == 0"
                    :loadingConnectBtn="isOctoConnecting"
                    @disableIntegration="disableIntegration()"
                    @connectIntegration="connect()"
                    @close="closeModal()"
                />
            </div>
        </div>
    </modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import Modal from '@/tools/modal/Modal'
import topArea from '../../components/integrations/integratePopup/popupParts/topArea.vue'
import bottomArea from '../../components/integrations/integratePopup/popupParts/bottomArea'

export default {
    data() {
        return {}
    },
    computed: {
        ...mapGetters([
            'getSelectedIntegration',
            'getIsOctoConnecting'
        ]),
        currentIntegration() {
            return this.getSelectedIntegration;
        },
        isOctoConnecting() {
            return this.getIsOctoConnecting;
        }
    },
    methods: {
        ...mapActions([
            'closeModal',
            'downloadSupplierIntegrations',
            'disableOctoIntegration',
            'enableOctoIntegration'
        ]),
        disableIntegration() {
            this.disableOctoIntegration(this.currentIntegration).then(response => {
                this.downloadSupplierIntegrations();
                this.closeModal();
            })
        },
        connect() {
            this.enableOctoIntegration(this.currentIntegration).then(response => {
                this.downloadSupplierIntegrations();
                this.closeModal();
            });
        },
        close() {
            this.closeModal();
        }
    },
    components: {
        topArea,
        bottomArea,
        Modal 
    }
}
</script>

<style lang="scss" scoped>
    .form-group-min-height {
        min-height: 107px;
    }
</style>



// WEBPACK FOOTER //
// octoIntegrations.vue?5c1084b4